<template>
  <ControlUnit
    :title="$t('control.panel.format')"
    :description="$t(`control.panel.format_descriptions.${currentDisplayMode}`)"
  >
    <InputSelect
      :name="unitName"
      :value="currentDisplayMode"
      :options="displayModes"
      @change="changeHandler"
    />
  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

import ControlUnit from './ControlUnit.vue';
import InputSelect from './InputSelect.vue';

export default {
  components: {
    ControlUnit,
    InputSelect,
  },
  setup() {
    const unitName = 'display-mode';

    const store = useStore();

    const displayModes = store.state.control.displayModes;

    const currentDisplayMode = computed(() => {
      return store.state.control.currentDisplayMode;
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);

      changeControlHandler({
        type: unitName,
        value: unitQueryValue,
      });
    });

    return {
      unitName,
      displayModes,
      currentDisplayMode,
      changeHandler,
    };
  },
};
</script>
